import React from "react";
import { BannerComponent } from "../../components";
import Breadcrumb from "./components/Breadcrumb";
import { Tabs } from 'antd';
import AboutUsTab from "./components/AboutUsTab";
import DevelopmentGoal from "./components/DevelopmentGoal";
import New from "./components/New";
import Recruitment from "./components/Recruitment";
import { useParams,useHistory } from "react-router-dom";
function AboutUs() {
    const { TabPane } = Tabs;
    const { source}=useParams();
    const history = useHistory()
  return (
    <div className="aboutUs">
      <BannerComponent />
      <Breadcrumb />
      <div className="UboutUsContent">
              <div className="tabList tabStyles">
                  <Tabs activeKey={source} defaultActiveKey="ve-mandala"
                      onChange={(key) => {
                          history.push(`/about-us/${key}`);
                      }}>
                      <TabPane tab="Về Mandala" key="ve-mandala">
                          <AboutUsTab />
                      </TabPane>

                      <TabPane tab="Mục tiêu phát triển" key="muc-tieu-phat-trien">
                          <DevelopmentGoal />
                      </TabPane>
                      <TabPane tab="Tin tức" key="tin-tuc">
                          <New />
                      </TabPane>
                      <TabPane tab="Tuyển dụng" key="tuyen-dung">
                          <   Recruitment />
                      </TabPane>
                  </Tabs>
              </div>
      </div>
    </div>
  );
}
export default AboutUs;
